module.exports = __webpack_public_path__ + "img/how_to_design_a_video_game_character_button.3d805063.jpg";